module.exports = __webpack_public_path__ + "img/bar-chart.bb6fcc80.svg";